// extracted by mini-css-extract-plugin
export default {"infoBlock":"documents_infoBlock__dsyNB","draftProposal":"documents_draftProposal__EouXh","desc":"documents_desc__ASjRm"};